import { baseTheme } from '@src/theme';
import React from 'react';
import { GoQuestion } from 'react-icons/go';
import { withTheme } from '../ThemeProvider';
import { StyledIconWrapper, StyledTooltip } from './styles';

export interface IHelpTooltip {
    help: React.ReactNode;
    theme?: any;
    iconSize?: number;
}

const HelpTooltipComponent: React.FC<IHelpTooltip> = ({
    help,
    iconSize = 16,
}: Readonly<IHelpTooltip>) => {
    return (
        <StyledTooltip title={help} placement="bottomLeft" arrow={false}>
            <StyledIconWrapper>
                <div
                    className="p-1 rounded-lg"
                    style={{
                        // TODO: should replace with theme conditions but for now using baseTheme (for side effect of using theme context)
                        backgroundColor:
                            baseTheme.colors.secondary.light.surfaceBg,
                    }}
                >
                    <GoQuestion
                        style={{ color: baseTheme.colors.info.main.icon }}
                        size={iconSize}
                    />
                </div>
            </StyledIconWrapper>
        </StyledTooltip>
    );
};

export const HelpTooltip = withTheme(HelpTooltipComponent);
